import { useEffect } from 'react';
import { isMobile } from 'react-device-detect';

export const useHideOriginTitlebar = () => {
  useEffect(() => {
    const headerDoms = document.querySelectorAll('.ant-layout-header');
    if (isMobile) {
      headerDoms.forEach((dom) => {
        dom.setAttribute('style', 'display: none');
      });
    }
    return () => {
      if (isMobile) {
        headerDoms.forEach((dom) => {
          dom.setAttribute('style', 'display: unset');
        });
      }
    };
  }, []);
};
